import { useMemo } from 'react'
import type { OrderRecord } from '@/types/dashboard'
import {
  createStudioReviewDataClient,
  type StudioReviewDataClient,
} from '@/services/dashboard-api'
import { useDashboardSlice, useReloadToken } from './dashboard-data-state'
import type { DashboardSlice } from './dashboard-data-state'

export interface OrdersData extends DashboardSlice<OrderRecord[]> {
  isLoading: boolean
  reload: () => void
}

export function useOrdersData(injectedClient?: StudioReviewDataClient): OrdersData {
  const defaultClient = useMemo(() => createStudioReviewDataClient(), [])
  const client = injectedClient ?? defaultClient
  const [reloadToken, reload] = useReloadToken()
  const slice = useDashboardSlice(
    'activity',
    () => client.readActivity(),
    [client],
    reloadToken,
  )
  return { ...slice, isLoading: slice.status === 'loading', reload }
}
